module.exports = __webpack_public_path__ + "img/c04_buildingtechpaidlabor_Normal_ua.9ad6c8df.webp";